import { useState } from 'react';
import './bookeventspopup.css';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { PayPalScriptProvider, PayPalButtons } from '@paypal/react-paypal-js';
import api from "../../api/axios";

const BookEventsPopUp = ({ event, onClose }) => {

    const { t } = useTranslation();
    const navigate = useNavigate();
    const [paypalError, setPaypalError] = useState(null);
    const [photoConsent, setPhotoConsent] = useState(false);

    const formatDateToUTCPlus2 = (date) => {
        const options = {
            timeZone: 'Europe/Berlin',
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
        };
        const dateTimeFormat = new Intl.DateTimeFormat('sv-SE', options);
        const parts = dateTimeFormat.formatToParts(new Date(date));

        const year = parts.find(part => part.type === 'year').value;
        const month = parts.find(part => part.type === 'month').value;
        const day = parts.find(part => part.type === 'day').value;

        return `${year}-${month}-${day}`;
    };

    const handleBooking = async (e) => {
        e.preventDefault();

        try {
            await api.post("/user/bookevent", {
                eventid: event.eventid,
            });

            navigate("/profile", { state: { bookedEvent: event } });
        } catch (error) {
            if (error.response?.status === 400) {
                alert(error.response.data);
            } else if (error.response?.status === 401) {
                alert("Please log in again.");
            } else {
                console.error("Error booking event:", error);
            }
        }
    };

    const handleCreatePaypalOrder = async () => {
        try {
            const response = await api.post("/user/paypal/createorder", {
                eventid: event.eventid,
            });
            return response.data.orderID;
        } catch (error) {
            console.error("Error creating PayPal order:", error);
            setPaypalError("Failed to create PayPal order. Please try again.");
            throw error;
        }
    };

    const handleApprovePaypal = async (data) => {
        try {
            const response = await api.post("/user/paypal/captureorder", {
                orderID: data.orderID,
                eventid: event.eventid,
            });

            if (response.status === 200) {
                navigate("/profile", { state: { bookedEvent: event } });
            }
        } catch (error) {
            if (error.response?.status === 400) {
                alert(error.response.data.error || error.response.data);
            } else if (error.response?.status === 401) {
                alert("Please log in again.");
            } else {
                console.error("Error capturing PayPal payment:", error);
                setPaypalError("Payment failed. Please try again.");
            }
        }
    };

    const isFreeEvent = parseFloat(event.price || 0) === 0;

    return (
        <div className="events-buchen-overlay">
            <div className="events-buchen-container">
                <h2>{event.eventname}</h2>
                <button onClick={onClose} aria-label="Close">&times;</button>
                <p><strong>{t('BookedEventsEventType')}</strong> {event.eventname}</p>
                <p><strong>{t('BookedEventsDate')}</strong> {new Date(event.date).toLocaleDateString('de-DE')}</p>
                <p><strong>{t('BookedEventsDescription')}</strong> {event.description}</p>
                <p><strong>{t('BookedEventsPrice')}</strong> {isFreeEvent ? t('BookedEventsFree') : `${parseFloat(event.price).toFixed(2)} \u20AC`}</p>

                <label className="photo-consent-label">
                    <input
                        type="checkbox"
                        checked={photoConsent}
                        onChange={(e) => setPhotoConsent(e.target.checked)}
                    />
                    <span>{t('BookedEventsPhotoConsent')}</span>
                </label>

                {isFreeEvent ? (
                    <button onClick={handleBooking} className="free-event-button" disabled={!photoConsent}>{t('BookedEventsFreeJoin')}</button>
                ) : (
                    <>
                        {photoConsent && (
                            <PayPalScriptProvider options={{
                                clientId: process.env.REACT_APP_PAYPAL_CLIENT_ID,
                                currency: "EUR",
                                intent: "capture"
                            }}>
                                <div className="paypal-button-wrapper">
                                    <PayPalButtons
                                        style={{ layout: "horizontal", color: "blue", label: "pay", height: 40 }}
                                        createOrder={handleCreatePaypalOrder}
                                        onApprove={handleApprovePaypal}
                                        onError={(err) => {
                                            console.error("PayPal error:", err);
                                            setPaypalError("PayPal encountered an error. Please try again.");
                                        }}
                                    />
                                </div>
                            </PayPalScriptProvider>
                        )}

                        {paypalError && <p style={{ color: 'red', marginTop: '8px' }}>{paypalError}</p>}
                    </>
                )}
            </div>
        </div>
    );
};

export default BookEventsPopUp;
